// Remove a máscara (pontos e espaços) da linha digitável, deixando só os
// dígitos — usado para copiar os dígitos "crus" (CA06).
export default function stripLinhaDigitavel(linhaDigitavel) {
  return String(linhaDigitavel || '').replace(/\D/g, '');
}
